function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M8.00558 0.416595C7.73886 0.149855 7.37708 0 6.99986 0C6.62263 0 6.26086 0.149855 5.99413 0.416595L0.419829 5.99124L0.412678 5.99853C0.0166773 6.39753 -0.107042 6.99238 0.0970319 7.51618C0.301106 8.03997 0.794651 8.39435 1.35622 8.42031C1.3729 8.42171 1.38973 8.42241 1.40628 8.42241H1.46503V12.3624C1.46565 13.2663 2.19809 13.9989 3.10195 13.9997H5.28377C5.59514 13.9995 5.84756 13.7473 5.84802 13.4359V10.2179C5.84833 9.93712 6.07585 9.70961 6.3566 9.7093H7.64367C7.92443 9.70961 8.15194 9.93712 8.15225 10.2179V13.4359C8.15256 13.7473 8.40494 13.9997 8.71636 14H10.8982C11.8019 13.9992 12.5343 13.2668 12.5352 12.3631V8.42311H12.5773C13.152 8.42316 13.6703 8.0774 13.8909 7.54675C14.1116 7.01611 13.9912 6.40482 13.5859 5.99741L8.00558 0.416595Z",
  fill: "#37517F"
});

const SvgHomeFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Home-Filled.96c58d2b.svg";
export { ForwardRef as ReactComponent };